module.exports = __webpack_public_path__ + "static/media/visaTravel.030be4e9.png";